import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { ReceptionStatusManagerAutoSwipeDelayQueryDocument } from '@docpace/reception-status-graphql/dist/urql.types'
import { ReceptionStatusManagerAutoSwipeDelayQueryResultFragment } from '@docpace/reception-status-graphql'

const typedReceptionStatusManagerAutoSwipeDelayQueryDocument = ReceptionStatusManagerAutoSwipeDelayQueryDocument as TypedDocumentNode<ReceptionStatusManagerAutoSwipeDelayQueryResultFragment>

export function useReceptionStatusManagerAutoSwipeDelayQuery(opts?: useQuery.Options<ReceptionStatusManagerAutoSwipeDelayQueryResultFragment>){
    return useQuery(typedReceptionStatusManagerAutoSwipeDelayQueryDocument, opts)
}
